import React, { useState, useEffect, useCallback } from "react";

import { ReactComponent as CloseSVG } from "../../../svg/notifyClose.svg";
// import { NotificationContainer, Icon } from "./NotificationStyled";
import useSound from "use-sound";
import notify from "../../../audio/notify.mp3";
import {
  NotificationFrame,
  Scaling,
  NotificationContainer,
  Icon,
} from "./NotificationStyled";

export default function Notification({
  notifyText,
  handleNotification,
  fadeOut,
  sound,
  volume,
}) {
  const [notifySfx] = useSound(notify, { volume });
  useEffect(() => {
    if (sound) notifySfx();
  }, [sound, notifySfx]);
  const [intViewportHeight, setintViewportHeight] = useState(667);

  const handleResize = useCallback((a) => {
    if (window.innerHeight < 667) {
      setintViewportHeight(window.innerHeight);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
  }, [handleResize]);
  return (
    <NotificationFrame className="NotificationFrame">
      <Scaling className="Scaling" h={intViewportHeight}>
        <NotificationContainer fadeOut={fadeOut}>
          <Icon />
          <p>{notifyText}</p>
          <CloseSVG onClick={() => handleNotification(false)} />
        </NotificationContainer>
      </Scaling>
    </NotificationFrame>
  );
}
